import React from 'react';

const Section = ({ id, title, items, theme = 'default' }) => {
    const themes = {
        default: 'bg-dark-bg',
        dark: 'bg-gray-900/50',
        darker: 'bg-black/50',
    };

    return (
        <section id={id} className={`${themes[theme]} relative overflow-hidden`}>
            
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-dark-bg/30"></div>

            <div className="relative py-24 z-10"> 
                <div className="section-container">
                    <h2 className="text-4xl md:text-5xl font-bold mb-16 text-center heading-gradient pb-4"> 
                        {title}
                    </h2>

                    <div className="grid md:grid-cols-3 gap-10">
                        {items.map((item, index) => (
                            <div
                                key={index}
                                className="bg-dark-card rounded-xl p-8 border border-gray-800 hover:border-neon-red transition-all duration-300 hover:translate-y-[-4px] flex flex-col h-full" 
                            >
                                <div className="flex items-center mb-6 flex-shrink-0"> 
                                    <div className="w-12 h-12 rounded-full bg-neon-red/20 flex items-center justify-center mr-4">
                                        <span className="text-neon-red font-bold text-lg">{index + 1}</span>
                                    </div>
                                    <h3 className="text-xl font-bold text-neon-red">{item.title}</h3>
                                </div>
                                <p className="text-gray-300 leading-relaxed text-lg flex-grow"> 
                                    {item.description}
                                </p>
                                
                                <div className="h-6 flex-shrink-0"></div> 
                            </div>
                        ))}
                    </div>

                    
                    <div className="h-16"></div>
                </div>
            </div>
        </section>
    );
};

export default Section;